import { ApiStatus } from 'Constants';
const handleConsent = () => {
    return {
        status: ApiStatus.OK,
    };
};
export const consentHandlers = [
    {
        match: /consent$/,
        handle: handleConsent,
        method: 'POST',
        name: 'consent',
    },
];
